import { Component, Input } from '@angular/core';

@Component({
  selector: 'ins-modal-body2',
  templateUrl: './modal-body2.component.html',
  styleUrls: ['./modal-body2.component.scss'],
})
export class ModalBody2Component {
  @Input() bottomBorder = false;
  @Input() noPadding = false;
}
